<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Customização</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Customização</div>
        </div>
      </div>

      <!-- Cores -->
      <section class="appui-card">
        <h2 class="appui-sec-title">Cores</h2>
        <p class="appui-sec-sub">Cores da identidade visual do app do evento.</p>
        <div class="appui-grid-3">
          <label v-for="c in colorFields" :key="c.key" class="appui-color-row">
            <span class="appui-swatch" :style="{ background: colors[c.key] || '#ffffff' }">
              <input type="color" :value="colors[c.key] || '#ffffff'" @input="onColor(c.key, $event.target.value)">
            </span>
            <span style="flex:1">
              <span style="display:block;font-weight:500;font-size:12.5px;color:#495057">{{ c.label }}</span>
              <span class="appui-hex">{{ colors[c.key] || '—' }}</span>
            </span>
          </label>
        </div>
      </section>

      <!-- Imagens -->
      <section class="appui-card">
        <h2 class="appui-sec-title" style="margin-bottom:16px">Imagens</h2>
        <div class="appui-grid-3">
          <div v-for="img in imageFields" :key="img.key">
            <label class="appui-label">{{ img.label }}</label>
            <input :ref="'file_' + img.key" type="file" accept="image/*" style="display:none" @change="onImage(img.key, $event)">
            <div class="appui-drop" :class="{ 'has-img': images[img.key] }" @click="pick(img.key)">
              <template v-if="images[img.key]">
                <img :src="images[img.key]" class="appui-drop-img">
                <div class="appui-drop-overlay">
                  <span class="appui-drop-btn"><i class="mdi mdi-swap-horizontal"></i> Trocar</span>
                  <span class="appui-drop-btn appui-drop-btn--danger" @click.stop="removeImage(img.key)"><i class="mdi mdi-delete"></i> Remover</span>
                </div>
              </template>
              <template v-else>
                <i class="mdi mdi-cloud-upload-outline appui-drop-icon"></i>
                <span class="appui-drop-title">Clique para enviar</span>
                <span class="appui-drop-hint">{{ img.hint }}</span>
              </template>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: {},
  name: 'app-customization',
  data () {
    return {
      colors: {},
      images: {},
      colorFields: [
        { key: 'color_header', label: 'Cor do Header' },
        { key: 'color_icon_header', label: 'Cor ícone Header' },
        { key: 'app_color_bg_primary', label: 'Cor primária' },
        { key: 'app_color_button_primary', label: 'Cor de botões' },
        { key: 'app_color_svg', label: 'Cor de ícones' },
        { key: 'app_color_font_primary', label: 'Cor de texto' }
      ],
      imageFields: [
        { key: 'app_logo_header', label: 'Imagem de logotipo', hint: 'Recomendado: 200x150 pixels, formato PNG' },
        { key: 'app_banner_login', label: 'Imagem banner de autenticação', hint: 'Recomendado: 1500x1072 pixels' },
        { key: 'app_banner_profile', label: 'Imagem banner perfil', hint: 'Recomendado: 1500x935 pixels' }
      ],
      colorTimer: null
    }
  },
  mounted () {
    const loader = this.$loading.show()
    services.getAppSettings()
      .then(res => { this.colors = { ...res.data.data.colors }; this.images = { ...res.data.data.images } })
      .catch(() => errorMessage('Falha ao carregar customização.', 3000))
      .finally(() => loader.hide())
  },
  methods: {
    pick (key) {
      const ref = this.$refs['file_' + key]
      if (ref && ref[0]) ref[0].click()
    },
    onColor (key, value) {
      this.$set(this.colors, key, value)
      clearTimeout(this.colorTimer)
      this.colorTimer = setTimeout(() => this.saveColors(), 400)
    },
    async saveColors () {
      try { await services.updateColors(this.colors); successMessage('Cores atualizadas.', 1200) } catch (e) { errorMessage('Falha ao salvar cores.', 3000) }
    },
    async onImage (field, event) {
      const file = event.target.files[0]
      if (!file) return
      const loader = this.$loading.show()
      try {
        const res = await services.uploadImage(field, file)
        this.images = { ...res.data.data }
        successMessage('Imagem atualizada.', 1500)
      } catch (e) {
        errorMessage('Falha ao enviar imagem.', 3000)
      } finally {
        loader.hide()
        const ref = this.$refs['file_' + field]
        if (ref && ref[0]) ref[0].value = ''
      }
    },
    async removeImage (field) {
      const loader = this.$loading.show()
      try { const res = await services.deleteImage(field); this.images = { ...res.data.data } } catch (e) { errorMessage('Falha ao remover imagem.', 3000) } finally { loader.hide() }
    }
  }
}
</script>
